import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StripepayPage } from './stripepay.page';

const routes: Routes = [
  {
    path: '',
    component: StripepayPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StripepayPageRoutingModule {}
